module.exports = __webpack_public_path__ + "2d06f772777f142d61c28cc133267b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox_connected_large_2x.png
// module id = 39
// module chunks = 0 1 2 3 4